import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Async thunk to fetch company token
export const fetchCompanyToken = createAsyncThunk(
  "companyToken/fetchCompanyToken",
  async (token) => {
    // Simulating an API call with a static object
    const staticData = {
      baseUrl: "https://aisStaging.watsoo.com",
      image: require("../../Images/loginBg.jpg"),
      companyID: "12345",
    };
    return staticData;
  }
);

const companyTokenSlice = createSlice({
  name: "companyToken",
  initialState: {
    token: null,
    image: "",
    baseUrl: "",
    companyID: "",
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyToken.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCompanyToken.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.baseUrl = action.payload.baseUrl;
        state.image = action.payload.image;
        state.companyID = action.payload.companyID;
      })
      .addCase(fetchCompanyToken.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default companyTokenSlice.reducer;
